import React from "react";
import clsx from "clsx";
import { nanoid } from "nanoid";
import s from "~/components/Table/TableRow/SRRTableRow/TableRow.less";

/**
 * Содержимое таблицы UVIN: Лояльность (1ая таблица)
 * Количество уникальных а/м (VIN) по годам владения, заехавших за последние 12 мес
 * @param row
 * @constructor
 */
export const ReportReturnLoyaltyServiceUniqueVINTable = ({ row }) => {
  return (
    <tr className={clsx(s.row_tr, s.row_td)}>
      {row.map((el, i) => (
        <td
          key={nanoid()}
          className={clsx(s.tdTO)}
          style={{ maxWidth: 100, overflow: "hidden" }}
        >
          <div>
            <span className={s.cont}>{el}</span>
          </div>
        </td>
      ))}
    </tr>
  );
};

/**
 * Содержимое таблицы UVIN: Лояльность (2ая таблица)
 * Количество проданных а/м по годам
 * @param row
 * @constructor
 */
export const ReportReturnLoyaltyServiceSalesTable = ({ row }) => {
  return (
    <tr className={clsx(s.row_tr, s.row_td)}>
      {row.map((el, i) => (
        <td
          key={nanoid()}
          className={clsx(s.tdTO)}
          style={{ maxWidth: 100, overflow: "hidden" }}
        >
          <div>
            <span className={s.cont}>{el}</span>
          </div>
        </td>
      ))}
    </tr>
  );
};

/**
 * Содержимое таблицы UVIN: Лояльность (3я таблица)
 * % лояльности по годам
 * @param row
 * @constructor
 */
export const ReportReturnLoyaltyServicePercentTable = ({ row }) => {
  return (
    <tr className={clsx(s.row_tr, s.row_td)}>
      {row.map((el, i) => (
        <td
          key={nanoid()}
          className={clsx(s.tdTO)}
          style={{ maxWidth: 100, overflow: "hidden" }}
        >
          <div>
            <span className={s.cont}>{el}</span>
          </div>
        </td>
      ))}
    </tr>
  );
};
